import { useEffect, useState } from 'react';

/**
 * A hook that manages a blob URL for a File or Blob object.
 * Automatically revokes the URL when the object changes or the component unmounts.
 */
export function useObjectUrl(file: File | Blob | undefined | null): string | undefined {
  const [objectUrl, setObjectUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!file) {
      setObjectUrl(undefined);
      return;
    }

    const url = URL.createObjectURL(file);
    setObjectUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  return objectUrl;
}

